/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'
import {
  updateTimelineAnnotation,
  deleteTimelineAnnotation,
  addTimelineAnnotation,
  getTimelineAnnotationsByTopicId
} from './asyncThunks'
import { TopicAnnotationsSlice } from './types'

const initialState: Readonly<TopicAnnotationsSlice> = {}

const topicAnnotationsSlice = createSlice({
  name: 'topicAnnotations',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTimelineAnnotationsByTopicId.pending, (state, action) => {
        state[action.meta.arg.topicId] = {
          ...state[action.meta.arg.topicId],
          status: 'loading'
        }
      })
      .addCase(getTimelineAnnotationsByTopicId.fulfilled, (state, action) => {
        state[action.meta.arg.topicId] = {
          annotations: action.payload.timelineAnnotations ?? [],
          status: 'success'
        }
      })
      .addCase(getTimelineAnnotationsByTopicId.rejected, (state, action) => {
        state[action.meta.arg.topicId] = {
          annotations: [],
          status: 'failure',
          error: action.payload
        }
      })
      .addMatcher(
        (action) =>
          action.type === updateTimelineAnnotation.pending.type ||
          action.type === deleteTimelineAnnotation.pending.type ||
          action.type === addTimelineAnnotation.pending.type,
        (state, action) => {
          const topicId = action.meta.arg.annotation.groupId
          state[topicId].status = 'operating'
          state[topicId].operatingId = action.meta.arg.annotation.id
        }
      )
      .addMatcher(
        (action) =>
          action.type === updateTimelineAnnotation.fulfilled.type ||
          action.type === deleteTimelineAnnotation.fulfilled.type ||
          action.type === addTimelineAnnotation.fulfilled.type,
        (state, action) => {
          const topicId = action.meta.arg.annotation.groupId
          state[topicId].status = 'success'
          state[topicId].operatingId = undefined

          if (action.type === updateTimelineAnnotation.fulfilled.type) {
            const index = state[topicId].annotations.findIndex(
              (annotation) => annotation.id === action.payload.id
            )
            state[topicId].annotations[index] = {
              ...state[topicId].annotations[index],
              ...action.payload
            }
          }
          if (action.type === deleteTimelineAnnotation.fulfilled.type) {
            state[topicId].annotations = state[topicId].annotations.filter(
              (annotation) => annotation.id !== action.meta.arg.annotation.id
            )
          }
        }
      )
      .addMatcher(
        (action) =>
          action.type === updateTimelineAnnotation.rejected.type ||
          action.type === deleteTimelineAnnotation.rejected.type ||
          action.type === addTimelineAnnotation.rejected.type,
        (state, action) => {
          const topicId = action.meta.arg.annotation.groupId
          state[topicId].status = 'failure'
          state[topicId].error = action.payload
          state[topicId].operatingId = action.meta.arg.annotation.id
        }
      )
  }
})

export default topicAnnotationsSlice.reducer
